import script from "./GestionActiviades.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionActiviades.vue?vue&type=script&setup=true&lang=js"

import "./GestionActiviades.vue?vue&type=style&index=0&id=1ee5a2b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee5a2b0"]])

export default __exports__